import api from "../utils/axiosConfig";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import "../css/userForms.css";
import img from "../STC_logo-01.png";
import localforage from "localforage";
import punjabGeoData from "../data/punjabGeography.json";

// ---- Punjab role options (derived from the geography) ----
const PJ_ROLE_TYPES = [
  { value: "admin", label: "Admin" },
  { value: "mod", label: "Moderator" },
  { value: "state", label: "State" },
  { value: "Zonal", label: "Zonal" },
  { value: "PCM", label: "PCM" },
];
const PJ_ACS = [];
Object.values(punjabGeoData.regions || {}).forEach((r) =>
  Object.entries(r.districts || {}).forEach(([d, list]) =>
    list.forEach((a) => PJ_ACS.push({ ...a, district: d, region: r.region }))
  )
);
const PJ_DISTRICTS = [...new Set(PJ_ACS.map((a) => a.district))].sort();
const PJ_TYPE_SET = new Set(PJ_ROLE_TYPES.map((o) => o.value));
const PJ_DISTRICT_SET = new Set(PJ_DISTRICTS);
const PJ_AC_SET = new Set(PJ_ACS.map((a) => a.ac_name));

// ---- AP role options ----
const AP_ZONES = ["Zone 1","Zone 2","Zone 3","Zone 4","Zone 5"];
const AP_PCS = ["2-Srikakulam","3-Vizianagaram","1-Araku","4-Visakhapatnam","5-Anakapalli","7-Amalapuram","8-Rajahmundry","6-Kakinada","9-Narsapuram","10-Eluru","11-Machilipatnam","12-Vijayawada","15-Bapatla","14-Narasaraopet","13-Guntur","16-Ongole","22-Nellore","23-Tirupati","21-Kadapa","24-Rajampet","18-Kurnool","17-Nandyal","19-Anantapur","20-Hindupur","25-Chittoor"];
const AP_ACS = ["6-Amadalavalasa","7-Etcherla","1-Ichapuram","8-Narasannapeta","10-Palakonda","2-Palasa","4-Pathapatnam","9-Rajam","5-Srikakulam","3-Tekkali","14-Bobbili","15-Cheepurupalli","16-Gajapathinagaram","11-Kurupam","17-Nellimarla","12-Parvathipuram","13-Salur","19-Srungavarapukota","18-Vizianagaram","30-Anakapalli","28-Araku Valley","20-Bhimili","26-Chodavaram","32-Elamanchili","25-Gajuwaka","27-Madugula","34-Narsipatnam","29-Paderu","33-Payakaraopeta","31-Pendurthi","21-Visakhapatnam East","23-Visakhapatnam North","22-Visakhapatnam South","24-Visakhapatnam West","44-Amalapuram","40-Anaparthy","46-Gannavaram (Eg)","52-Jaggampeta","41-Kakinada City","38-Kakinada Rural","47-Kothapeta","48-Mandapeta","43-Mummidivaram","39-Peddapuram","37-Pithapuram","36-Prathipad","50-Rajahmundry City","51-Rajahmundry Rural","49-Rajanagaram","42-Ramachandrapuram","53-Rampachodavaram","45-Razole","35-Tuni","56-Achanta","59-Bhimavaram","68-Chintalapudi","64-Dendulur","65-Eluru","66-Gopalpuram","54-Kovvur","58-Narasapur","55-Nidadavole","57-Palacole","67-Polavaram","62-Tadepalligudem","61-Tanuku","60-Undi","63-Ungutur","76-Avanigadda","71-Gannavaram (Krishna)","72-Gudivada","84-Jaggayyapet","73-Kaikalur","75-Machilipatnam","82-Mylavaram","83-Nandigama","70-Nuzvid","77-Pamarru","74-Pedana","78-Penamaluru","69-Tiruvuru","80-Vijayawada Central","81-Vijayawada East","79-Vijayawada West","92-Bapatla","96-Chilakaluripet","95-Guntur East","94-Guntur West","100-Gurzala","101-Macherla","87-Mangalagiri","97-Narasaraopet","85-Peddakurapadu","88-Ponnur","93-Prathipadu","90-Repalle","98-Sattenapalli","86-Tadikonda","91-Tenali","89-Vemuru","99-Vinukonda","105-Addanki","106-Chirala","103-Darsi","112-Giddalur","109-Kandukur","113-Kanigiri","110-Kondepi","111-Markapur","108-Ongole","104-Parchur","107-Santhanuthalapadu","102-Yerragondapalem","115-Atmakur","120-Gudur","114-Kavali","116-Kovur","117-Nellore City","118-Nellore Rural","119-Sarvepalli","121-Sullurpet","123-Udayagiri","122-Venkatagiri","124-Badvel","131-Jammalamadugu","126-Kadapa","130-Kamalapuram","127-Kodur","133-Mydukur","132-Proddatur","129-Pulivendla","125-Rajampet","128-Rayachoty","146-Adoni","134-Allagadda","147-Alur","140-Banaganapalle","141-Dhone","143-Kodumur","137-Kurnool","145-Mantralayam","136-Nandikotkur","139-Nandyal","138-Panyam","142-Pattikonda","135-Srisailam","144-Yemmiganur","153-Anantapur Urban","160-Dharmavaram","150-Guntakal","157-Hindupur","161-Kadiri","154-Kalyandurg","156-Madakasira","158-Penukonda","159-Puttaparthi","155-Raptadu","148-Rayadurg","152-Singanamala","151-Tadpatri","149-Uravakonda","166-Chandragiri","172-Chittoor","171-Gangadhara Nellore","175-Kuppam","164-Madanpalle","170-Nagari","174-Palamaner","163-Pileru","165-Punganur","173-Puthalapattu","169-Satyavedu","168-Srikalahasti","162-Thamballapalle","167-Tirupati"];
const AP_DISTRICTS = ["Srikakulam","Parvathipuram Manyam","Vizianagaram","Anakapalli","Alluri Sitharama Raju","Visakhapatnam","Konaseema","East Godavari","Kakinada","West Godavari","Eluru","Krishna","NTR","Bapatla","Palnadu","Guntur","Prakasam","Nellore","Tirupati","Kadapa","Annamayya","Kurnool","Nandyal","Anantapur","Sri Sathya Sai","Chittoor"];
const AP_ROLE_TYPES = [
  { value: "user", label: "User" },
  { value: "state", label: "State" },
  { value: "admin", label: "Admin" },
  { value: "mod", label: "Moderator" },
  { value: "Zonal", label: "Zonal" },
  { value: "State Lead", label: "State Lead" },
  { value: "PCM", label: "PCM" },
];
const AP_TYPE_SET = new Set(AP_ROLE_TYPES.map((o) => o.value));
const AP_ZONE_SET = new Set(AP_ZONES);
const AP_PC_SET = new Set(AP_PCS);
const AP_AC_SET = new Set(AP_ACS);

const API_URL = process.env.REACT_APP_API_URL;

const UpdateUser = () => {
  const { userId } = useParams();
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [location, setLocation] = useState("");
  const [roles, setRoles] = useState([]);
  const [reportingManagerEmail, setReportingManagerEmail] = useState("");
  const [reportingManagerName, setReportingManagerName] = useState("");
  const [secondaryReportingManagerEmail, setSecondaryReportingManagerEmail] =
    useState("");
  const [secondaryReportingManagerName, setSecondaryReportingManagerName] =
    useState("");
  const [managerOptions, setManagerOptions] = useState([]);
  const [department, setDepartment] = useState("");
  const [team, setTeam] = useState("");
  const history = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const handleRoleChange = (selectedRoles) => {
    setRoles(selectedRoles.map((role) => role.value));
  };

  // Punjab selects each own a slice of the single `roles` array. Replace only
  // that slice so the three Punjab pickers don't clobber each other.
  const replaceRoleSubset = (ownedSet, selectedValues) => {
    setRoles((prev) => {
      const kept = prev.filter((v) => !ownedSet.has(v));
      return [...kept, ...selectedValues];
    });
  };
  const handlePjTypeChange = (sel) =>
    replaceRoleSubset(PJ_TYPE_SET, (sel || []).map((o) => o.value));
  const handlePjDistrictChange = (sel) =>
    replaceRoleSubset(PJ_DISTRICT_SET, (sel || []).map((o) => o.value));
  const handlePjAcChange = (sel) =>
    replaceRoleSubset(PJ_AC_SET, (sel || []).map((o) => o.value));
  const handleApTypeChange = (sel) =>
    replaceRoleSubset(AP_TYPE_SET, (sel || []).map((o) => o.value));
  const handleApZoneChange = (sel) =>
    replaceRoleSubset(AP_ZONE_SET, (sel || []).map((o) => o.value));
  const handleApPcChange = (sel) =>
    replaceRoleSubset(AP_PC_SET, (sel || []).map((o) => o.value));
  const handleApAcChange = (sel) =>
    replaceRoleSubset(AP_AC_SET, (sel || []).map((o) => o.value));

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.put(`${API_URL}/auth/update-user/${userId}`, {
        userName,
        email,
        roles,
        location,
        reportingManagerEmail,
        reportingManagerName,
        secondaryReportingManagerEmail,
        secondaryReportingManagerName,
        department,
        team,
      });
      alert("User updated successfully!");
      history("/userdashboard");
    } catch (error) {
      console.error(
        "Update failed:",
        error.response?.data?.message || error.message
      );
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = await localforage.getItem("token");
        const response = await api.get(`${API_URL}/auth/users/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const userData = response.data;
        setUser(userData);
        setEmail(userData.email || "");
        setUserName(userData.userName || "");
        setLocation(userData.location || "");
        setRoles(userData.roles || []);
        setReportingManagerEmail(userData.reportingManagerEmail || "");
        setReportingManagerName(userData.reportingManagerName || "");
        setSecondaryReportingManagerEmail(
          userData.secondaryReportingManagerEmail || ""
        );
        setSecondaryReportingManagerName(
          userData.secondaryReportingManagerName || ""
        );
        setDepartment(userData.department || "");
        setTeam(userData.team || "");
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user:", error);
        setError("Failed to fetch user");
        setLoading(false);
      }
    };

    // Load all users to populate the reporting-manager dropdowns (searchable).
    const fetchManagers = async () => {
      try {
        const token = await localforage.getItem("token");
        const res = await api.get(`${API_URL}/auth/users`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const opts = (res.data || [])
          .filter((u) => u && u.email && u.userName)
          .map((u) => ({ value: u.email, label: u.userName, email: u.email }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setManagerOptions(opts);
      } catch (error) {
        console.error("Error fetching managers:", error);
      }
    };
    fetchManagers();

    if (userId) {
      fetchUser();
    } else {
      setError("User ID is missing");
      setLoading(false);
    }
  }, [userId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  const customStyles = {
    indicatorSeparator: (provided, state) => ({
      ...provided,
      display:
        state.selectProps.value && state.selectProps.value.length > 0
          ? "block"
          : "none",
    }),
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "2px solid #4CAF50" : "2px solid #ccc",
      borderRadius: "4px",
      boxShadow: state.isFocused ? "0 0 5px rgba(76, 175, 80, 0.7)" : "none",
      cursor: "pointer",
    }),
  };

  const roleOptions = [
    { value: "admin", label: "Admin" },
    { value: "mod", label: "Moderator" },
    { value: "user", label: "User" },
    { value: "state", label: "State" },
    { value: "Eastern Vidarbha", label: "Eastern Vidarbha" },
    { value: "Konkan", label: "Konkan" },
    { value: "Marathwada", label: "Marathwada" },
    { value: "Mumbai", label: "Mumbai" },
    { value: "Northern Maharashtra", label: "Northern Maharashtra" },
    { value: "Thane + Palghar", label: "Thane + Palghar" },
    { value: "Western Vidarbha", label: "Western Vidarbha" },
    { value: "Western Maharashtra", label: "Western Maharashtra" },
    { value: "Ahmednagar", label: "Ahmednagar" },
    { value: "Akola", label: "Akola" },
    { value: "Washim", label: "Washim" },
    { value: "Amravati", label: "Amravati" },
    {
      value: "Chhatrapati Sambhaji Nagar",
      label: "Chhatrapati Sambhaji Nagar",
    },
    { value: "Pune", label: "Pune" },
    { value: "Beed", label: "Beed" },
    { value: "Bhandara", label: "Bhandara" },
    { value: "Gondiya", label: "Gondiya" },
    { value: "Thane", label: "Thane" },
    { value: "Buldhana", label: "Buldhana" },
    { value: "Chandrapur", label: "Chandrapur" },
    { value: "Yavatmal", label: "Yavatmal" },
    { value: "Dhule", label: "Dhule" },
    { value: "Nashik", label: "Nashik" },
    { value: "Gadchiroli", label: "Gadchiroli" },
    { value: "Kolhapur", label: "Kolhapur" },
    { value: "Sangli", label: "Sangli" },
    { value: "Nanded", label: "Nanded" },
    { value: "Hingoli", label: "Hingoli" },
    { value: "Jalgaon", label: "Jalgaon" },
    { value: "Jalna", label: "Jalna" },
    { value: "Latur", label: "Latur" },
    { value: "Solapur", label: "Solapur" },
    { value: "Satara", label: "Satara" },
    { value: "Raigad", label: "Raigad" },
    { value: "Mumbai (Suburban)", label: "Mumbai (Suburban)" },
    { value: "Mumbai City", label: "Mumbai City" },
    { value: "Nagpur", label: "Nagpur" },
    { value: "Nandurbar", label: "Nandurbar" },
    { value: "Dharashiv", label: "Dharashiv" },
    { value: "Palghar", label: "Palghar" },
    { value: "Parbhani", label: "Parbhani" },
    { value: "Ratnagiri", label: "Ratnagiri" },
    { value: "Sindhudurg", label: "Sindhudurg" },
    { value: "Wardha", label: "Wardha" },
    { value: "1-Akkalkuwa(ST)", label: "1-Akkalkuwa(ST)" },
    { value: "2-Shahada(ST)", label: "2-Shahada(ST)" },
    { value: "3-Nandurbar(ST)", label: "3-Nandurbar(ST)" },
    { value: "4-Nawapur(ST)", label: "4-Nawapur(ST)" },
    { value: "5-Sakri(ST)", label: "5-Sakri(ST)" },
    { value: "6-Dhule Rural", label: "6-Dhule Rural" },
    { value: "7-Dhule City", label: "7-Dhule City" },
    { value: "8-Sindhkheda", label: "8-Sindhkheda" },
    { value: "9-Shirpur(ST)", label: "9-Shirpur(ST)" },
    { value: "10-Chopda(ST)", label: "10-Chopda(ST)" },
    { value: "11-Raver", label: "11-Raver" },
    { value: "12-Bhusawal(SC)", label: "12-Bhusawal(SC)" },
    { value: "13-Jalgaon City", label: "13-Jalgaon City" },
    { value: "14-Jalgaon Rural", label: "14-Jalgaon Rural" },
    { value: "15-Amalner", label: "15-Amalner" },
    { value: "16-Erandol", label: "16-Erandol" },
    { value: "17-Chalisgaon", label: "17-Chalisgaon" },
    { value: "18-Pachora", label: "18-Pachora" },
    { value: "19-Jamner", label: "19-Jamner" },
    { value: "20-Muktainagar", label: "20-Muktainagar" },
    { value: "21-Malkapur", label: "21-Malkapur" },
    { value: "22-Buldhana", label: "22-Buldhana" },
    { value: "23-Chikhli", label: "23-Chikhli" },
    { value: "24-Sindhkhed Raja", label: "24-Sindhkhed Raja" },
    { value: "25-Mehkar(SC)", label: "25-Mehkar(SC)" },
    { value: "26-Khamgaon", label: "26-Khamgaon" },
    { value: "27-Jalgaon(Jamod)", label: "27-Jalgaon(Jamod)" },
    { value: "28-Akot", label: "28-Akot" },
    { value: "29-Balapur", label: "29-Balapur" },
    { value: "30-Aakola West", label: "30-Aakola West" },
    { value: "31-Akola East", label: "31-Akola East" },
    { value: "32-Murtizapur(SC)", label: "32-Murtizapur(SC)" },
    { value: "33-Risod", label: "33-Risod" },
    { value: "34-Washim(SC)", label: "34-Washim(SC)" },
    { value: "35-Karanja", label: "35-Karanja" },
    { value: "36-Dhamangaon Railway", label: "36-Dhamangaon Railway" },
    { value: "37-Badnera", label: "37-Badnera" },
    { value: "38-Amrawati", label: "38-Amrawati" },
    { value: "39-Teosa", label: "39-Teosa" },
    { value: "40-Daryapur(SC)", label: "40-Daryapur(SC)" },
    { value: "41-Melghat(ST)", label: "41-Melghat(ST)" },
    { value: "42-Achalpur", label: "42-Achalpur" },
    { value: "43-Morshi", label: "43-Morshi" },
    { value: "44-Arvi", label: "44-Arvi" },
    { value: "45-Deoli", label: "45-Deoli" },
    { value: "46-Hinganghat", label: "46-Hinganghat" },
    { value: "47-Wardha", label: "47-Wardha" },
    { value: "48-Katol", label: "48-Katol" },
    { value: "49-Savner", label: "49-Savner" },
    { value: "50-Hingna", label: "50-Hingna" },
    { value: "51-Umred(SC)", label: "51-Umred(SC)" },
    { value: "52-Nagpur South West", label: "52-Nagpur South West" },
    { value: "53-Nagpur South", label: "53-Nagpur South" },
    { value: "54-Nagpur East", label: "54-Nagpur East" },
    { value: "55-Nagpur Central", label: "55-Nagpur Central" },
    { value: "56-Nagpur West", label: "56-Nagpur West" },
    { value: "57-Nagpur North(SC)", label: "57-Nagpur North(SC)" },
    { value: "58-Kamthi", label: "58-Kamthi" },
    { value: "59-Ramtek", label: "59-Ramtek" },
    { value: "60-Tumsar", label: "60-Tumsar" },
    { value: "61-Bhandara(SC)", label: "61-Bhandara(SC)" },
    { value: "62-Sakoli", label: "62-Sakoli" },
    { value: "63-Arjuni Morgaon(SC)", label: "63-Arjuni Morgaon(SC)" },
    { value: "64-Tirora", label: "64-Tirora" },
    { value: "65-Gondia", label: "65-Gondia" },
    { value: "66-Amgaon(ST)", label: "66-Amgaon(ST)" },
    { value: "67-Armori(ST)", label: "67-Armori(ST)" },
    { value: "68-Gadchiroli(ST)", label: "68-Gadchiroli(ST)" },
    { value: "69-Aheri(ST)", label: "69-Aheri(ST)" },
    { value: "70-Rajura", label: "70-Rajura" },
    { value: "71-Chandrapur(SC)", label: "71-Chandrapur(SC)" },
    { value: "72-Ballarpur", label: "72-Ballarpur" },
    { value: "73-Bramhapuri", label: "73-Bramhapuri" },
    { value: "74-Chimur", label: "74-Chimur" },
    { value: "75-Warora", label: "75-Warora" },
    { value: "76-Wani", label: "76-Wani" },
    { value: "77-Ralegaon(ST)", label: "77-Ralegaon(ST)" },
    { value: "78-Yavatmal", label: "78-Yavatmal" },
    { value: "79-Digras", label: "79-Digras" },
    { value: "80-Arni(ST)", label: "80-Arni(ST)" },
    { value: "81-Pusad", label: "81-Pusad" },
    { value: "82-Umarkhed(SC)", label: "82-Umarkhed(SC)" },
    { value: "83-Kinwat", label: "83-Kinwat" },
    { value: "84-Hidgaon", label: "84-Hidgaon" },
    { value: "85-Bhokar", label: "85-Bhokar" },
    { value: "86-Nanded North", label: "86-Nanded North" },
    { value: "87-Nanded south", label: "87-Nanded south" },
    { value: "88-Loha", label: "88-Loha" },
    { value: "89-Naigaon", label: "89-Naigaon" },
    { value: "90-Deglur(sc)", label: "90-Deglur(sc)" },
    { value: "91-Mukhed", label: "91-Mukhed" },
    { value: "92-Basmath", label: "92-Basmath" },
    { value: "93-Kalamnuri", label: "93-Kalamnuri" },
    { value: "94-Hingoli", label: "94-Hingoli" },
    { value: "95-Jintur", label: "95-Jintur" },
    { value: "96-Parbhani", label: "96-Parbhani" },
    { value: "97-Gangakhed", label: "97-Gangakhed" },
    { value: "98-Pathri", label: "98-Pathri" },
    { value: "99-Partur", label: "99-Partur" },
    { value: "100-Gansavangi", label: "100-Gansavangi" },
    { value: "101-Jalna", label: "101-Jalna" },
    { value: "102-Badnapur(SC)", label: "102-Badnapur(SC)" },
    { value: "103-Bhokardan", label: "103-Bhokardan" },
    { value: "104-Sillod", label: "104-Sillod" },
    { value: "105-Kannad", label: "105-Kannad" },
    { value: "106-Pholambari", label: "106-Pholambari" },
    {
      value: "107-Chatrapati Sambhaji Nagar(Central)",
      label: "107-Chatrapati Sambhaji Nagar(Central)",
    },
    {
      value: "108-Chatrapati Sambhaji Nagar(West)(SC)",
      label: "108-Chatrapati Sambhaji Nagar(West)(SC)",
    },
    { value: "109-Aurangbad(East)", label: "109-Aurangbad(East)" },
    { value: "110-Paithan", label: "110-Paithan" },
    { value: "111-Gangapur", label: "111-Gangapur" },
    { value: "112-Vaijapur", label: "112-Vaijapur" },
    { value: "113-Nandgaon", label: "113-Nandgaon" },
    { value: "114-Malegaon(Central)", label: "114-Malegaon(Central)" },
    { value: "115-Malegaon(Outer)", label: "115-Malegaon(Outer)" },
    { value: "116-Baglan(ST)", label: "116-Baglan(ST)" },
    { value: "117-Kalwan(ST)", label: "117-Kalwan(ST)" },
    { value: "118-Chandwad", label: "118-Chandwad" },
    { value: "119-Yevla", label: "119-Yevla" },
    { value: "120-Sinnar", label: "120-Sinnar" },
    { value: "121-Niphad", label: "121-Niphad" },
    { value: "122-Dindori(ST)", label: "122-Dindori(ST)" },
    { value: "123-Nashik East", label: "123-Nashik East" },
    { value: "124-Nashik(Central)", label: "124-Nashik(Central)" },
    { value: "125-Nashik West", label: "125-Nashik West" },
    { value: "126-Deolali(SC)", label: "126-Deolali(SC)" },
    { value: "127-Igatpuri(ST)", label: "127-Igatpuri(ST)" },
    { value: "128-Dahanu(ST)", label: "128-Dahanu(ST)" },
    { value: "129-Vekramgrth(ST)", label: "129-Vekramgrth(ST)" },
    { value: "130-Palghar(ST)", label: "130-Palghar(ST)" },
    { value: "131-Boisar(ST)", label: "131-Boisar(ST)" },
    { value: "132-Nalasopara", label: "132-Nalasopara" },
    { value: "133-Vasai", label: "133-Vasai" },
    { value: "134-Bhiwandi Rural(ST)", label: "134-Bhiwandi Rural(ST)" },
    { value: "135-Shahapur(ST)", label: "135-Shahapur(ST)" },
    { value: "136-Bhiwandi West", label: "136-Bhiwandi West" },
    { value: "137-Bhiwandi East", label: "137-Bhiwandi East" },
    { value: "138-Kalyan West", label: "138-Kalyan West" },
    { value: "139-Murbad", label: "139-Murbad" },
    { value: "140-Ambarnath(SC)", label: "140-Ambarnath(SC)" },
    { value: "141-Ulhasnagar", label: "141-Ulhasnagar" },
    { value: "142-Kalyan East", label: "142-Kalyan East" },
    { value: "143-Dombivali", label: "143-Dombivali" },
    { value: "144-Kalyan Rural", label: "144-Kalyan Rural" },
    { value: "145-Meera Bhayandar", label: "145-Meera Bhayandar" },
    { value: "146-ovala majiwada", label: "146-ovala majiwada" },
    { value: "147-Kopri-Pachpakhadi", label: "147-Kopri-Pachpakhadi" },
    { value: "148-Thane", label: "148-Thane" },
    { value: "149-Mumbra-Kalwa", label: "149-Mumbra-Kalwa" },
    { value: "150-Airoli", label: "150-Airoli" },
    { value: "151-Belapur", label: "151-Belapur" },
    { value: "152-Borivali", label: "152-Borivali" },
    { value: "153-Dhaisar", label: "153-Dhaisar" },
    { value: "154-Magathane", label: "154-Magathane" },
    { value: "155-Mulund", label: "155-Mulund" },
    { value: "156-Vikhroli", label: "156-Vikhroli" },
    { value: "157-Bhandup West", label: "157-Bhandup West" },
    { value: "158-Jogeshwari East", label: "158-Jogeshwari East" },
    { value: "159-Dindoshi", label: "159-Dindoshi" },
    { value: "160-Kandivali East", label: "160-Kandivali East" },
    { value: "161-Charkop", label: "161-Charkop" },
    { value: "162-Malad West", label: "162-Malad West" },
    { value: "163-Goregaon", label: "163-Goregaon" },
    { value: "164-Varsova", label: "164-Varsova" },
    { value: "165-Andheri West", label: "165-Andheri West" },
    { value: "166-Andheri East", label: "166-Andheri East" },
    { value: "167-Vile Parle", label: "167-Vile Parle" },
    { value: "168-Chandivali", label: "168-Chandivali" },
    { value: "169-Ghatkopar West", label: "169-Ghatkopar West" },
    { value: "170-Ghatkopar East", label: "170-Ghatkopar East" },
    { value: "171-Mankhurd Shivajinagar", label: "171-Mankhurd Shivajinagar" },
    { value: "172-Anushakti Nagar", label: "172-Anushakti Nagar" },
    { value: "173-Chembur", label: "173-Chembur" },
    { value: "174-Kurla (sc)", label: "174-Kurla (sc)" },
    { value: "175-Kalina", label: "175-Kalina" },
    { value: "176-Vandre East", label: "176-Vandre East" },
    { value: "177-Vandre West", label: "177-Vandre West" },
    { value: "178-Dharavi", label: "178-Dharavi" },
    { value: "179-Sion Koliwada", label: "179-Sion Koliwada" },
    { value: "180-Wadala", label: "180-Wadala" },
    { value: "181-Mahim", label: "181-Mahim" },
    { value: "182-Worli", label: "182-Worli" },
    { value: "183-Shivadi", label: "183-Shivadi" },
    { value: "184-Byculla", label: "184-Byculla" },
    { value: "185-Malabar Hill", label: "185-Malabar Hill" },
    { value: "186-Mumbadevi", label: "186-Mumbadevi" },
    { value: "187-Colaba", label: "187-Colaba" },
    { value: "188-Panvel", label: "188-Panvel" },
    { value: "189-Karjat", label: "189-Karjat" },
    { value: "190-Uran", label: "190-Uran" },
    { value: "191-Pen", label: "191-Pen" },
    { value: "192-alibag", label: "192-alibag" },
    { value: "193-Shrivardhan", label: "193-Shrivardhan" },
    { value: "194-mahad", label: "194-mahad" },
    { value: "195-Junnar", label: "195-Junnar" },
    { value: "196-Ambegaon", label: "196-Ambegaon" },
    { value: "197-Khed Alandi", label: "197-Khed Alandi" },
    { value: "198-Shirur", label: "198-Shirur" },
    { value: "199-Daund", label: "199-Daund" },
    { value: "200-Indapur", label: "200-Indapur" },
    { value: "201-Baramati", label: "201-Baramati" },
    { value: "202-Purandar", label: "202-Purandar" },
    { value: "203-Bhor", label: "203-Bhor" },
    { value: "204-Maval", label: "204-Maval" },
    { value: "205-Chinchwad", label: "205-Chinchwad" },
    { value: "206-Pimpri(SC)", label: "206-Pimpri(SC)" },
    { value: "207-Bhosari", label: "207-Bhosari" },
    { value: "208-Vadgaon Sheri", label: "208-Vadgaon Sheri" },
    { value: "209-Shivajinagar", label: "209-Shivajinagar" },
    { value: "210-Kothrud", label: "210-Kothrud" },
    { value: "211-Khadakwasala", label: "211-Khadakwasala" },
    { value: "212-Parvati", label: "212-Parvati" },
    { value: "213-Hadapsar", label: "213-Hadapsar" },
    { value: "214-Pune Cantonment(SC)", label: "214-Pune Cantonment(SC)" },
    { value: "215-Kasba Peth", label: "215-Kasba Peth" },
    { value: "216-Akole(ST)", label: "216-Akole(ST)" },
    { value: "217-Sangmner", label: "217-Sangmner" },
    { value: "218-Shirdi", label: "218-Shirdi" },
    { value: "219-Kopargaon", label: "219-Kopargaon" },
    { value: "220-Shrirampur(SC)", label: "220-Shrirampur(SC)" },
    { value: "221-Nevasa", label: "221-Nevasa" },
    { value: "222-Shevgaon", label: "222-Shevgaon" },
    { value: "223-Rahuri", label: "223-Rahuri" },
    { value: "224-Parner", label: "224-Parner" },
    { value: "225-Ahmednagar City", label: "225-Ahmednagar City" },
    { value: "226-Shrigonda", label: "226-Shrigonda" },
    { value: "227-Karjat Jamkhed", label: "227-Karjat Jamkhed" },
    { value: "228-Georai", label: "228-Georai" },
    { value: "229-Majalgaon", label: "229-Majalgaon" },
    { value: "230-Beed", label: "230-Beed" },
    { value: "231-Ashti", label: "231-Ashti" },
    { value: "232-Kaij(SC)", label: "232-Kaij(SC)" },
    { value: "233-Parli", label: "233-Parli" },
    { value: "234-Latur Rural", label: "234-Latur Rural" },
    { value: "235-Latur City", label: "235-Latur City" },
    { value: "236-Ahmedpur", label: "236-Ahmedpur" },
    { value: "237-Udgir(SC)", label: "237-Udgir(SC)" },
    { value: "238-Nilanga", label: "238-Nilanga" },
    { value: "239-Ausa", label: "239-Ausa" },
    { value: "240-Omerga(SC)", label: "240-Omerga(SC)" },
    { value: "241-Tuljapur", label: "241-Tuljapur" },
    { value: "242-Dharashiv", label: "242-Dharashiv" },
    { value: "243-Paranda", label: "243-Paranda" },
    { value: "244-Karmala", label: "244-Karmala" },
    { value: "245-Madha", label: "245-Madha" },
    { value: "246-Barshi", label: "246-Barshi" },
    { value: "247-Mohol(SC)", label: "247-Mohol(SC)" },
    { value: "248-solapur north", label: "248-solapur north" },
    { value: "249-solapur central", label: "249-solapur central" },
    { value: "250-Akkalkot", label: "250-Akkalkot" },
    { value: "251-Solapur South", label: "251-Solapur South" },
    { value: "252-Pandharpur", label: "252-Pandharpur" },
    { value: "253-Sangola", label: "253-Sangola" },
    { value: "254-Malshiran(SC)", label: "254-Malshiran(SC)" },
    { value: "255-Phaltan(SC)", label: "255-Phaltan(SC)" },
    { value: "256-Wai", label: "256-Wai" },
    { value: "257-koregaon", label: "257-koregaon" },
    { value: "258-Man", label: "258-Man" },
    { value: "259-Karad North", label: "259-Karad North" },
    { value: "260-Karad South", label: "260-Karad South" },
    { value: "261-patan", label: "261-patan" },
    { value: "262-Satara", label: "262-Satara" },
    { value: "263-Dapoli", label: "263-Dapoli" },
    { value: "264-Guhagar", label: "264-Guhagar" },
    { value: "265-Chiplun", label: "265-Chiplun" },
    { value: "266-Ratnagiri", label: "266-Ratnagiri" },
    { value: "267-Rajapur", label: "267-Rajapur" },
    { value: "268-Kankavli", label: "268-Kankavli" },
    { value: "269-Kudal", label: "269-Kudal" },
    { value: "270-Sawantwadi", label: "270-Sawantwadi" },
    { value: "271-Chandgad", label: "271-Chandgad" },
    { value: "272-Radhanagari", label: "272-Radhanagari" },
    { value: "273-kagal", label: "273-kagal" },
    { value: "274-Kolhapur South", label: "274-Kolhapur South" },
    { value: "275-Karvir", label: "275-Karvir" },
    { value: "276-Kolhapur North", label: "276-Kolhapur North" },
    { value: "277-Shahuwadi", label: "277-Shahuwadi" },
    { value: "278-Hatkanangle(SC)", label: "278-Hatkanangle(SC)" },
    { value: "279-Ichalkaranji", label: "279-Ichalkaranji" },
    { value: "280-Shirol", label: "280-Shirol" },
    { value: "281-Miraj(SC)", label: "281-Miraj(SC)" },
    { value: "282-Sangli", label: "282-Sangli" },
    { value: "283-islampur", label: "283-islampur" },
    { value: "284-Shirala", label: "284-Shirala" },
    { value: "285-Palus-Kadegaon", label: "285-Palus-Kadegaon" },
    { value: "286-Khanpur", label: "286-Khanpur" },
    { value: "287-Tasgaon-Kavathe", label: "287-Tasgaon-Kavathe" },
    { value: "288-Jat", label: "288-Jat" },
    { value: "1-Nandurbar (ST)", label: "1-Nandurbar (ST)" },
    { value: "10-Nagpur", label: "10-Nagpur" },
    { value: "11-Bhandara-Gondiya", label: "11-Bhandara-Gondiya" },
    { value: "12-Gadchiroli-Chimur (ST)", label: "12-Gadchiroli-Chimur (ST)" },
    { value: "13-Chandrapur", label: "13-Chandrapur" },
    { value: "14-Yavatmal-Washim", label: "14-Yavatmal-Washim" },
    { value: "15-Hingoli", label: "15-Hingoli" },
    { value: "16-Nanded", label: "16-Nanded" },
    { value: "17-Parbhani", label: "17-Parbhani" },
    { value: "18-Jalna", label: "18-Jalna" },
    {
      value: "19-Chatrapati Sambhaji Nagar",
      label: "19-Chatrapati Sambhaji Nagar",
    },
    { value: "2-Dhule", label: "2-Dhule" },
    { value: "20-Dindori (ST)", label: "20-Dindori (ST)" },
    { value: "21-Nashik", label: "21-Nashik" },
    { value: "22-Palghar (ST)", label: "22-Palghar (ST)" },
    { value: "23-Bhiwandi", label: "23-Bhiwandi" },
    { value: "24-Kalyan", label: "24-Kalyan" },
    { value: "25-Thane", label: "25-Thane" },
    { value: "26-Mumbai North", label: "26-Mumbai North" },
    { value: "27-Mumbai North-West", label: "27-Mumbai North-West" },
    { value: "28-Mumbai North-East", label: "28-Mumbai North-East" },
    { value: "29-Mumbai North-Central", label: "29-Mumbai North-Central" },
    { value: "3-Jalgaon", label: "3-Jalgaon" },
    { value: "30-Mumbai South-Central", label: "30-Mumbai South-Central" },
    { value: "31-Mumbai South", label: "31-Mumbai South" },
    { value: "32-Raigad", label: "32-Raigad" },
    { value: "33-Maval", label: "33-Maval" },
    { value: "34-Pune", label: "34-Pune" },
    { value: "35-Baramati", label: "35-Baramati" },
    { value: "36-Shirur", label: "36-Shirur" },
    { value: "37-Ahmednagar", label: "37-Ahmednagar" },
    { value: "38-Shirdi (SC)", label: "38-Shirdi (SC)" },
    { value: "39-Beed", label: "39-Beed" },
    { value: "4-Raver", label: "4-Raver" },
    { value: "40-Dharashiv", label: "40-Dharashiv" },
    { value: "41-Latur (SC)", label: "41-Latur (SC)" },
    { value: "42-Solapur (SC)", label: "42-Solapur (SC)" },
    { value: "43-Madha", label: "43-Madha" },
    { value: "44-Sangli", label: "44-Sangli" },
    { value: "45-Satara", label: "45-Satara" },
    { value: "46-Ratnagiri-Sindhudurg", label: "46-Ratnagiri-Sindhudurg" },
    { value: "47-Kolhapur", label: "47-Kolhapur" },
    { value: "48-Hatkanangle", label: "48-Hatkanangle" },
    { value: "5-Buldhana", label: "5-Buldhana" },
    { value: "6-Akola", label: "6-Akola" },
    { value: "7-Amravati (SC)", label: "7-Amravati (SC)" },
    { value: "8-Wardha", label: "8-Wardha" },
    { value: "9-Ramtek (SC)", label: "9-Ramtek (SC)" },
  ];

  const roleApOptions = [
    { value: "admin", label: "Admin" },
    { value: "mod", label: "Moderator" },
    { value: "user", label: "User" },
    { value: "state", label: "State" },
    { value: "Zone 1", label: "Zone 1" },
    { value: "Zone 2", label: "Zone 2" },
    { value: "Zone 3", label: "Zone 3" },
    { value: "Zone 4", label: "Zone 4" },
    { value: "Zone 5", label: "Zone 5" },
    { value: "6-Amadalavalasa", label: "6-Amadalavalasa" },
    { value: "7-Etcherla", label: "7-Etcherla" },
    { value: "1-Ichapuram", label: "1-Ichapuram" },
    { value: "8-Narasannapeta", label: "8-Narasannapeta" },
    { value: "10-Palakonda", label: "10-Palakonda" },
    { value: "2-Palasa", label: "2-Palasa" },
    { value: "4-Pathapatnam", label: "4-Pathapatnam" },
    { value: "9-Rajam", label: "9-Rajam" },
    { value: "5-Srikakulam", label: "5-Srikakulam" },
    { value: "3-Tekkali", label: "3-Tekkali" },
    { value: "14-Bobbili", label: "14-Bobbili" },
    { value: "15-Cheepurupalli", label: "15-Cheepurupalli" },
    { value: "16-Gajapathinagaram", label: "16-Gajapathinagaram" },
    { value: "11-Kurupam", label: "11-Kurupam" },
    { value: "17-Nellimarla", label: "17-Nellimarla" },
    { value: "12-Parvathipuram", label: "12-Parvathipuram" },
    { value: "13-Salur", label: "13-Salur" },
    { value: "19-Srungavarapukota", label: "19-Srungavarapukota" },
    { value: "18-Vizianagaram", label: "18-Vizianagaram" },
    { value: "30-Anakapalli", label: "30-Anakapalli" },
    { value: "28-Araku Valley", label: "28-Araku Valley" },
    { value: "20-Bhimili", label: "20-Bhimili" },
    { value: "26-Chodavaram", label: "26-Chodavaram" },
    { value: "32-Elamanchili", label: "32-Elamanchili" },
    { value: "25-Gajuwaka", label: "25-Gajuwaka" },
    { value: "27-Madugula", label: "27-Madugula" },
    { value: "34-Narsipatnam", label: "34-Narsipatnam" },
    { value: "29-Paderu", label: "29-Paderu" },
    { value: "33-Payakaraopeta", label: "33-Payakaraopeta" },
    { value: "31-Pendurthi", label: "31-Pendurthi" },
    { value: "21-Visakhapatnam East", label: "21-Visakhapatnam East" },
    { value: "23-Visakhapatnam North", label: "23-Visakhapatnam North" },
    { value: "22-Visakhapatnam South", label: "22-Visakhapatnam South" },
    { value: "24-Visakhapatnam West", label: "24-Visakhapatnam West" },
    { value: "44-Amalapuram", label: "44-Amalapuram" },
    { value: "40-Anaparthy", label: "40-Anaparthy" },
    { value: "46-Gannavaram (Eg)", label: "46-Gannavaram (Eg)" },
    { value: "52-Jaggampeta", label: "52-Jaggampeta" },
    { value: "41-Kakinada City", label: "41-Kakinada City" },
    { value: "38-Kakinada Rural", label: "38-Kakinada Rural" },
    { value: "47-Kothapeta", label: "47-Kothapeta" },
    { value: "48-Mandapeta", label: "48-Mandapeta" },
    { value: "43-Mummidivaram", label: "43-Mummidivaram" },
    { value: "39-Peddapuram", label: "39-Peddapuram" },
    { value: "37-Pithapuram", label: "37-Pithapuram" },
    { value: "36-Prathipad", label: "36-Prathipad" },
    { value: "50-Rajahmundry City", label: "50-Rajahmundry City" },
    { value: "51-Rajahmundry Rural", label: "51-Rajahmundry Rural" },
    { value: "49-Rajanagaram", label: "49-Rajanagaram" },
    { value: "42-Ramachandrapuram", label: "42-Ramachandrapuram" },
    { value: "53-Rampachodavaram", label: "53-Rampachodavaram" },
    { value: "45-Razole", label: "45-Razole" },
    { value: "35-Tuni", label: "35-Tuni" },
    { value: "56-Achanta", label: "56-Achanta" },
    { value: "59-Bhimavaram", label: "59-Bhimavaram" },
    { value: "68-Chintalapudi", label: "68-Chintalapudi" },
    { value: "64-Dendulur", label: "64-Dendulur" },
    { value: "65-Eluru", label: "65-Eluru" },
    { value: "66-Gopalpuram", label: "66-Gopalpuram" },
    { value: "54-Kovvur", label: "54-Kovvur" },
    { value: "58-Narasapur", label: "58-Narasapur" },
    { value: "55-Nidadavole", label: "55-Nidadavole" },
    { value: "57-Palacole", label: "57-Palacole" },
    { value: "67-Polavaram", label: "67-Polavaram" },
    { value: "62-Tadepalligudem", label: "62-Tadepalligudem" },
    { value: "61-Tanuku", label: "61-Tanuku" },
    { value: "60-Undi", label: "60-Undi" },
    { value: "63-Ungutur", label: "63-Ungutur" },
    { value: "76-Avanigadda", label: "76-Avanigadda" },
    { value: "71-Gannavaram (Krishna)", label: "71-Gannavaram (Krishna)" },
    { value: "72-Gudivada", label: "72-Gudivada" },
    { value: "84-Jaggayyapet", label: "84-Jaggayyapet" },
    { value: "73-Kaikalur", label: "73-Kaikalur" },
    { value: "75-Machilipatnam", label: "75-Machilipatnam" },
    { value: "82-Mylavaram", label: "82-Mylavaram" },
    { value: "83-Nandigama", label: "83-Nandigama" },
    { value: "70-Nuzvid", label: "70-Nuzvid" },
    { value: "77-Pamarru", label: "77-Pamarru" },
    { value: "74-Pedana", label: "74-Pedana" },
    { value: "78-Penamaluru", label: "78-Penamaluru" },
    { value: "69-Tiruvuru", label: "69-Tiruvuru" },
    { value: "80-Vijayawada Central", label: "80-Vijayawada Central" },
    { value: "81-Vijayawada East", label: "81-Vijayawada East" },
    { value: "79-Vijayawada West", label: "79-Vijayawada West" },
    { value: "92-Bapatla", label: "92-Bapatla" },
    { value: "96-Chilakaluripet", label: "96-Chilakaluripet" },
    { value: "95-Guntur East", label: "95-Guntur East" },
    { value: "94-Guntur West", label: "94-Guntur West" },
    { value: "100-Gurzala", label: "100-Gurzala" },
    { value: "101-Macherla", label: "101-Macherla" },
    { value: "87-Mangalagiri", label: "87-Mangalagiri" },
    { value: "97-Narasaraopet", label: "97-Narasaraopet" },
    { value: "85-Peddakurapadu", label: "85-Peddakurapadu" },
    { value: "88-Ponnur", label: "88-Ponnur" },
    { value: "93-Prathipadu", label: "93-Prathipadu" },
    { value: "90-Repalle", label: "90-Repalle" },
    { value: "98-Sattenapalli", label: "98-Sattenapalli" },
    { value: "86-Tadikonda", label: "86-Tadikonda" },
    { value: "91-Tenali", label: "91-Tenali" },
    { value: "89-Vemuru", label: "89-Vemuru" },
    { value: "99-Vinukonda", label: "99-Vinukonda" },
    { value: "105-Addanki", label: "105-Addanki" },
    { value: "106-Chirala", label: "106-Chirala" },
    { value: "103-Darsi", label: "103-Darsi" },
    { value: "112-Giddalur", label: "112-Giddalur" },
    { value: "109-Kandukur", label: "109-Kandukur" },
    { value: "113-Kanigiri", label: "113-Kanigiri" },
    { value: "110-Kondepi", label: "110-Kondepi" },
    { value: "111-Markapur", label: "111-Markapur" },
    { value: "108-Ongole", label: "108-Ongole" },
    { value: "104-Parchur", label: "104-Parchur" },
    { value: "107-Santhanuthalapadu", label: "107-Santhanuthalapadu" },
    { value: "102-Yerragondapalem", label: "102-Yerragondapalem" },
    { value: "115-Atmakur", label: "115-Atmakur" },
    { value: "120-Gudur", label: "120-Gudur" },
    { value: "114-Kavali", label: "114-Kavali" },
    { value: "116-Kovur", label: "116-Kovur" },
    { value: "117-Nellore City", label: "117-Nellore City" },
    { value: "118-Nellore Rural", label: "118-Nellore Rural" },
    { value: "119-Sarvepalli", label: "119-Sarvepalli" },
    { value: "121-Sullurpet", label: "121-Sullurpet" },
    { value: "123-Udayagiri", label: "123-Udayagiri" },
    { value: "122-Venkatagiri", label: "122-Venkatagiri" },
    { value: "124-Badvel", label: "124-Badvel" },
    { value: "131-Jammalamadugu", label: "131-Jammalamadugu" },
    { value: "126-Kadapa", label: "126-Kadapa" },
    { value: "130-Kamalapuram", label: "130-Kamalapuram" },
    { value: "127-Kodur", label: "127-Kodur" },
    { value: "133-Mydukur", label: "133-Mydukur" },
    { value: "132-Proddatur", label: "132-Proddatur" },
    { value: "129-Pulivendla", label: "129-Pulivendla" },
    { value: "125-Rajampet", label: "125-Rajampet" },
    { value: "128-Rayachoty", label: "128-Rayachoty" },
    { value: "146-Adoni", label: "146-Adoni" },
    { value: "134-Allagadda", label: "134-Allagadda" },
    { value: "147-Alur", label: "147-Alur" },
    { value: "140-Banaganapalle", label: "140-Banaganapalle" },
    { value: "141-Dhone", label: "141-Dhone" },
    { value: "143-Kodumur", label: "143-Kodumur" },
    { value: "137-Kurnool", label: "137-Kurnool" },
    { value: "145-Mantralayam", label: "145-Mantralayam" },
    { value: "136-Nandikotkur", label: "136-Nandikotkur" },
    { value: "139-Nandyal", label: "139-Nandyal" },
    { value: "138-Panyam", label: "138-Panyam" },
    { value: "142-Pattikonda", label: "142-Pattikonda" },
    { value: "135-Srisailam", label: "135-Srisailam" },
    { value: "144-Yemmiganur", label: "144-Yemmiganur" },
    { value: "153-Anantapur Urban", label: "153-Anantapur Urban" },
    { value: "160-Dharmavaram", label: "160-Dharmavaram" },
    { value: "150-Guntakal", label: "150-Guntakal" },
    { value: "157-Hindupur", label: "157-Hindupur" },
    { value: "161-Kadiri", label: "161-Kadiri" },
    { value: "154-Kalyandurg", label: "154-Kalyandurg" },
    { value: "156-Madakasira", label: "156-Madakasira" },
    { value: "158-Penukonda", label: "158-Penukonda" },
    { value: "159-Puttaparthi", label: "159-Puttaparthi" },
    { value: "155-Raptadu", label: "155-Raptadu" },
    { value: "148-Rayadurg", label: "148-Rayadurg" },
    { value: "152-Singanamala", label: "152-Singanamala" },
    { value: "151-Tadpatri", label: "151-Tadpatri" },
    { value: "149-Uravakonda", label: "149-Uravakonda" },
    { value: "166-Chandragiri", label: "166-Chandragiri" },
    { value: "172-Chittoor", label: "172-Chittoor" },
    { value: "171-Gangadhara Nellore", label: "171-Gangadhara Nellore" },
    { value: "175-Kuppam", label: "175-Kuppam" },
    { value: "164-Madanpalle", label: "164-Madanpalle" },
    { value: "170-Nagari", label: "170-Nagari" },
    { value: "174-Palamaner", label: "174-Palamaner" },
    { value: "163-Pileru", label: "163-Pileru" },
    { value: "165-Punganur", label: "165-Punganur" },
    { value: "173-Puthalapattu", label: "173-Puthalapattu" },
    { value: "169-Satyavedu", label: "169-Satyavedu" },
    { value: "168-Srikalahasti", label: "168-Srikalahasti" },
    { value: "162-Thamballapalle", label: "162-Thamballapalle" },
    { value: "167-Tirupati", label: "167-Tirupati" },
    { value: "2-Srikakulam", label: "2-Srikakulam" },
    { value: "3-Vizianagaram", label: "3-Vizianagaram" },
    { value: "1-Araku", label: "1-Araku" },
    { value: "4-Visakhapatnam", label: "4-Visakhapatnam" },
    { value: "5-Anakapalli", label: "5-Anakapalli" },
    { value: "7-Amalapuram", label: "7-Amalapuram" },
    { value: "8-Rajahmundry", label: "8-Rajahmundry" },
    { value: "6-Kakinada", label: "6-Kakinada" },
    { value: "9-Narsapuram", label: "9-Narsapuram" },
    { value: "10-Eluru", label: "10-Eluru" },
    { value: "11-Machilipatnam", label: "11-Machilipatnam" },
    { value: "12-Vijayawada", label: "12-Vijayawada" },
    { value: "15-Bapatla", label: "15-Bapatla" },
    { value: "14-Narasaraopet", label: "14-Narasaraopet" },
    { value: "13-Guntur", label: "13-Guntur" },
    { value: "16-Ongole", label: "16-Ongole" },
    { value: "22-Nellore", label: "22-Nellore" },
    { value: "23-Tirupati", label: "23-Tirupati" },
    { value: "21-Kadapa", label: "21-Kadapa" },
    { value: "24-Rajampet", label: "24-Rajampet" },
    { value: "18-Kurnool", label: "18-Kurnool" },
    { value: "17-Nandyal", label: "17-Nandyal" },
    { value: "19-Anantapur", label: "19-Anantapur" },
    { value: "20-Hindupur", label: "20-Hindupur" },
    { value: "25-Chittoor", label: "25-Chittoor" },
    { value: "Srikakulam", label: "Srikakulam" },
    { value: "Parvathipuram Manyam", label: "Parvathipuram Manyam" },
    { value: "Vizianagaram", label: "Vizianagaram" },
    { value: "Anakapalli", label: "Anakapalli" },
    { value: "Alluri Sitharama Raju", label: "Alluri Sitharama Raju" },
    { value: "Visakhapatnam", label: "Visakhapatnam" },
    { value: "Konaseema", label: "Konaseema" },
    { value: "East Godavari", label: "East Godavari" },
    { value: "Kakinada", label: "Kakinada" },
    { value: "West Godavari", label: "West Godavari" },
    { value: "Eluru", label: "Eluru" },
    { value: "Krishna", label: "Krishna" },
    { value: "NTR", label: "NTR" },
    { value: "Bapatla", label: "Bapatla" },
    { value: "Palnadu", label: "Palnadu" },
    { value: "Guntur", label: "Guntur" },
    { value: "Prakasam", label: "Prakasam" },
    { value: "Nellore", label: "Nellore" },
    { value: "Tirupati", label: "Tirupati" },
    { value: "Kadapa", label: "Kadapa" },
    { value: "Annamayya", label: "Annamayya" },
    { value: "Kurnool", label: "Kurnool" },
    { value: "Nandyal", label: "Nandyal" },
    { value: "Anantapur", label: "Anantapur" },
    { value: "Sri Sathya Sai", label: "Sri Sathya Sai" },
    { value: "Chittoor", label: "Chittoor" },
  ];

  return (
    <div className="uf-page">
      <div className="uf-card uf-wide">
        <img src={img} className="img" alt="STC Logo" />
        <h1>Update User</h1>
        <form onSubmit={handleSubmit}>
          <div className="uf-grid2">
            <div>
              <label className="uf-label">Email</label>
              <input
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="uf-label">Name</label>
              <input
                type="text"
                placeholder="Enter Name"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="uf-label">State</label>
              <select
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              >
                <option value="">Select State</option>
                <option value="Andhra Pradesh">Andhra Pradesh</option>
                <option value="Maharashtra">Maharashtra</option>
                <option value="Punjab">Punjab</option>
                <option value="Uttar Pradesh">Uttar Pradesh</option>
                <option value="West Bengal">West Bengal</option>
              </select>
            </div>
            <div>
              <label className="uf-label">Team</label>
              <select value={team} onChange={(e) => setTeam(e.target.value)}>
                <option value="">Select Team</option>
                <option value="DMC">DMC</option>
                <option value="Soul central">Soul central</option>
                <option value="PMU">PMU</option>
                <option value="Field">Field</option>
              </select>
            </div>
            <div>
              <label className="uf-label">Primary Reporting Manager</label>
              <Select
                options={managerOptions}
                value={
                  managerOptions.find(
                    (o) => o.value === reportingManagerEmail
                  ) ||
                  (reportingManagerName
                    ? { value: reportingManagerEmail, label: reportingManagerName }
                    : null)
                }
                onChange={(opt) => {
                  setReportingManagerName(opt ? opt.label : "");
                  setReportingManagerEmail(opt ? opt.email : "");
                }}
                isClearable
                placeholder="Search and select manager…"
                styles={customStyles}
              />
            </div>
            <div>
              <label className="uf-label">Secondary Reporting Manager</label>
              <Select
                options={managerOptions}
                value={
                  managerOptions.find(
                    (o) => o.value === secondaryReportingManagerEmail
                  ) ||
                  (secondaryReportingManagerName
                    ? {
                        value: secondaryReportingManagerEmail,
                        label: secondaryReportingManagerName,
                      }
                    : null)
                }
                onChange={(opt) => {
                  setSecondaryReportingManagerName(opt ? opt.label : "");
                  setSecondaryReportingManagerEmail(opt ? opt.email : "");
                }}
                isClearable
                placeholder="Search and select manager…"
                styles={customStyles}
              />
            </div>
            <div className="uf-span2">
              <label className="uf-label">Department</label>
              <input
                type="text"
                placeholder="Enter department"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
              />
            </div>
            {location === "Andhra Pradesh" ? (
              <>
                <div className="uf-span2">
                  <label className="uf-label">Role (AP)</label>
                  <Select
                    options={AP_ROLE_TYPES}
                    value={AP_ROLE_TYPES.filter((o) => roles.includes(o.value))}
                    onChange={handleApTypeChange}
                    isMulti
                    styles={customStyles}
                    placeholder="Select role(s): User, State, Admin, Mod, Zonal, State Lead, PCM"
                  />
                </div>
                {(roles.includes("Zonal") ||
                  roles.includes("State Lead") ||
                  roles.includes("PCM")) && (
                  <>
                    <div className="uf-span2">
                      <label className="uf-label">Zone</label>
                      <Select
                        options={AP_ZONES.map((z) => ({ value: z, label: z }))}
                        value={AP_ZONES.filter((z) => roles.includes(z)).map((z) => ({
                          value: z,
                          label: z,
                        }))}
                        onChange={handleApZoneChange}
                        isMulti
                        styles={customStyles}
                        placeholder="Select zone(s)"
                      />
                    </div>
                    <div className="uf-span2">
                      <label className="uf-label">Parliament Constituency</label>
                      <Select
                        options={AP_PCS.map((pc) => ({ value: pc, label: pc }))}
                        value={AP_PCS.filter((pc) => roles.includes(pc)).map((pc) => ({
                          value: pc,
                          label: pc,
                        }))}
                        onChange={handleApPcChange}
                        isMulti
                        styles={customStyles}
                        placeholder="Select Parliament Constituency (multiple)"
                      />
                    </div>
                    <div className="uf-span2">
                      <label className="uf-label">Assembly Constituency</label>
                      <Select
                        options={AP_ACS.map((ac) => ({ value: ac, label: ac }))}
                        value={AP_ACS.filter((ac) => roles.includes(ac)).map((ac) => ({
                          value: ac,
                          label: ac,
                        }))}
                        onChange={handleApAcChange}
                        isMulti
                        styles={customStyles}
                        placeholder="Select Assembly Constituency (for AC-level mapping)"
                      />
                    </div>
                  </>
                )}
              </>
            ) : location === "Punjab" ? (
              <>
                <div className="uf-span2">
                  <label className="uf-label">Roles (Punjab)</label>
                  <Select
                    options={PJ_ROLE_TYPES}
                    value={PJ_ROLE_TYPES.filter((o) => roles.includes(o.value))}
                    onChange={handlePjTypeChange}
                    isMulti
                    styles={customStyles}
                    placeholder="Select role(s): PCM, Zonal, State, Admin, Mod"
                  />
                </div>
                {(roles.includes("Zonal") || roles.includes("PCM")) && (
                  <>
                    <div className="uf-span2">
                      <label className="uf-label">District (mapping)</label>
                      <Select
                        options={PJ_DISTRICTS.map((d) => ({ value: d, label: d }))}
                        value={PJ_DISTRICTS.filter((d) => roles.includes(d)).map(
                          (d) => ({ value: d, label: d })
                        )}
                        onChange={handlePjDistrictChange}
                        isMulti
                        styles={customStyles}
                        placeholder="Select district(s)"
                      />
                    </div>
                    <div className="uf-span2">
                      <label className="uf-label">AC Name (mapping)</label>
                      <Select
                        options={PJ_ACS.filter((a) => {
                          const selD = roles.filter((r) => PJ_DISTRICT_SET.has(r));
                          return selD.length === 0 || selD.includes(a.district);
                        }).map((a) => ({
                          value: a.ac_name,
                          label: `${a.ac_no ? a.ac_no + " — " : ""}${a.ac_name} (${a.district})`,
                        }))}
                        value={PJ_ACS.filter((a) => roles.includes(a.ac_name)).map(
                          (a) => ({
                            value: a.ac_name,
                            label: `${a.ac_no ? a.ac_no + " — " : ""}${a.ac_name}`,
                          })
                        )}
                        onChange={handlePjAcChange}
                        isMulti
                        styles={customStyles}
                        placeholder="Select AC(s) to map"
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div className="uf-span2">
                  <label className="uf-label">Roles</label>
                  <Select
                    options={roleOptions}
                    value={roleOptions.filter((option) =>
                      roles.includes(option.value)
                    )}
                    onChange={handleRoleChange}
                    isMulti
                    styles={customStyles}
                  />
                </div>
                <div className="uf-span2">
                  <label className="uf-label">Roles (AP)</label>
                  <Select
                    options={roleApOptions}
                    value={roleApOptions.filter((option) =>
                      roles.includes(option.value)
                    )}
                    onChange={handleRoleChange}
                    isMulti
                    styles={customStyles}
                  />
                </div>
              </>
            )}
          </div>
          <button type="submit">Update User</button>
        </form>
      </div>
    </div>
  );
};

export default UpdateUser;
